import { render, staticRenderFns } from "./ticket-collaborator.html?vue&type=template&id=394c57c0&scoped=true&"
import script from "./ticket-collaborator.js?vue&type=script&lang=js&"
export * from "./ticket-collaborator.js?vue&type=script&lang=js&"
import style0 from "../Tiket.scss?vue&type=style&index=0&id=394c57c0&lang=true&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394c57c0",
  null
  
)

export default component.exports